/* eslint-disable eag/match-named-export */
import {Option} from './VehicleCatalogueLogic';

export enum VehicleTypeEnumObject {
  VEHICLETYPE_CARAVAN = 'VEHICLETYPE_CARAVAN',
  VEHICLETYPE_PASSENGER_CAR = 'VEHICLETYPE_PASSENGER_CAR',
  VEHICLETYPE_VAN = 'VEHICLETYPE_VAN',
  VEHICLETYPE_MOTORCYCLE = 'VEHICLETYPE_MOTORCYCLE',
  VEHICLETYPE_TRUCK = 'VEHICLETYPE_TRUCK',
  VEHICLETYPE_SEMI_TRAILER = 'VEHICLETYPE_SEMI_TRAILER',
  VEHICLETYPE_TRAILER = 'VEHICLETYPE_TRAILER',
  VEHICLETYPE_BUS = 'VEHICLETYPE_BUS',
  VEHICLETYPE_OTHER = 'VEHICLETYPE_OTHER',
  VEHICLETYPE_AGRICULTURAL_MACHINE = 'VEHICLETYPE_AGRICULTURAL_MACHINE',
  VEHICLETYPE_CONSTRUCTION_MACHINE = 'VEHICLETYPE_CONSTRUCTION_MACHINE',
  VEHICLETYPE_SEMI_TRUCK = 'VEHICLETYPE_SEMI_TRUCK',
}

type VehicleModel = {
  default_label: string;
  labels?: {
    label: string;
    language: string;
  }[];
  model: string;
  model_group?: {
    default_label: string;
    group: string;
    labels?: {
      label: string;
      language: string;
    }[];
  } | null;
};

type VehicleMakeModel = {
  default_label: string;
  labels?: {
    label: string;
    label_short?: string | null;
    language: string;
  }[];
  make: string;
  models?: VehicleModel[];
  vehicle_type: string;
};

export type VehicleMakeModelData = VehicleMakeModel[];

type ModelFamily = {
  isCustom: boolean;
};

type Make = {
  models: {
    [key: string]: ModelFamily;
  };
  isCustom: boolean;
};

type VehicleType = {
  makes: {
    [key: string]: Make;
  };
};

export type CustomTenantMakeModelData = {
  [key: string]: VehicleType;
};

type TopMake = {
  code: string;
};

export type TopMakesData = /** status 200  */ TopMake[];

export type GroupType = {
  label: string;
  options: readonly Option[];
};

export interface VehicleMakeDescriptor {
  /** Finalized data for UI picker */
  groupedMakeOptions: GroupType[];
  /** Ungrouped parts */
  detail: {
    /** Only globally recognized makes from Alpha catalogue */
    globalMakes: Option[];
    /** Only custom makes known in this tenant */
    customMakes: Option[];
    /** All makes combined [global, custom, unknown] */
    flatMakes: Option[];
  };
}

export interface VehicleModelDescriptor {
  /** Finalized data for UI picker */
  groupedModelOptions: GroupType[];
  /** Ungrouped parts */
  detail: {
    /** Only globally recognized models from Alpha catalogue */
    globalModels: Option[];
    /** Only custom models known in this tenant */
    customModels: Option[];
    /** All models combined [global, custom, unknown] */
    flatModels: Option[];
  };
}
